import React, { Component } from 'react';
import AttachmentService from 'services/attachment';
import QuestionService from 'services/question';
import RequestService from 'services/request';
import ResponseService from 'services/response';

class DownloadAttachment extends Component {
    async componentDidMount() {
        const { attachmentId, attachmentType = 'request', entityId, requestId } = this.props.match.params;
        const attachmentOwnerId = entityId || requestId;
        const service = this.getAttachmentService(attachmentType);

        if (!service) {
            this.setState({ error: 'The attachment type is not supported.' });
            return;
        }

        try {
            const [attachments, file] = await Promise.all([
                service.getAttachments(attachmentOwnerId),
                service.getAttachmentFile(attachmentOwnerId, attachmentId),
            ]);
            const attachment = attachments.find(item => item.id === Number(attachmentId));

            if (!attachment) {
                throw new Error('Attachment metadata was not found.');
            }

            AttachmentService.openFile(file, attachment.contentType, attachment.name);
        } catch (error) {
            console.error('Unable to download attachment.', error);
            this.setState({ error: 'The attachment could not be downloaded.' });
    }
    }

    getAttachmentService(attachmentType) {
        const services = {
            request: RequestService,
            question: QuestionService,
            response: ResponseService,
        };

        return services[attachmentType];
    }

    render() {
        return <div>{this.state && this.state.error ? this.state.error : 'Downloading attachment...'}</div>;
    }
}

export default DownloadAttachment;